import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SIGN_IN } from 'src/redux/authReducer'
import { RootReducer } from 'src/redux/rootReducer'

const SignIn = (): JSX.Element => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { error, isLoading } = useSelector((state: RootReducer) => state.authReducer)

  return (
    <div className="relative">
      <img src="/admin-public/assets/images/login-background.jpg" className="w-screen h-screen" />
      <div className="absolute w-screen h-screen top-0 right-0 flex items-center justify-center z-20">
        <div className="bg-darkGrey flex-1 max-w-[25rem] p-6">
          <input
            value={email}
            placeholder="Email"
            onChange={(e) => {
              setEmail(e.target.value)
            }}
            className="w-full h-8 rounded-sm px-2"
          />
          <div className="h-2" />
          <input
            onChange={(e) => {
              setPassword(e.target.value)
            }}
            value={password}
            placeholder="Password"
            type="password"
            className="w-full h-8 rounded-sm px-2"
          />
          {error !== null && (
            <>
              <div className="h-2" />
              <div style={{ color: '#dc2626' }} className="text-sm text-center">
                {error}
              </div>
            </>
          )}
          <div className="h-4" />
          <button
            onClick={() => dispatch(SIGN_IN({ email, password }))}
            disabled={isLoading}
            className="bg-orange py-2 text-center rounded-md cursor-pointer w-full disabled:opacity-50 disabled:cursor-not-allowed">
            {isLoading ? 'Logging in...' : 'Login in'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SignIn
